module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Generate url feeds from on air panel or campaigns\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "158px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Generate For"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.isGenerateForOnAir),
      callback: function($$v) {
        _vm.isGenerateForOnAir = $$v
      },
      expression: "isGenerateForOnAir"
    }
  }, [_c('el-radio', {
    attrs: {
      "border": "",
      "label": true
    }
  }, [_vm._v("On Air")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "border": "",
      "label": false
    }
  }, [_vm._v("Campaign")])], 1)], 1), _vm._v(" "), (!_vm.isGenerateForOnAir) ? _c('el-form-item', {
    attrs: {
      "label": "Available Campaigns"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select",
      "filterable": ""
    },
    model: {
      value: (_vm.selectedId),
      callback: function($$v) {
        _vm.selectedId = $$v
      },
      expression: "selectedId"
    }
  }, _vm._l((_vm.activeCampaigns), function(campaign) {
    return _c('el-option', {
      key: campaign.id,
      attrs: {
        "label": campaign.title,
        "value": campaign.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isGenerateForOnAir) ? _c('el-form-item', {
    attrs: {
      "label": "Available Users"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select",
      "filterable": ""
    },
    model: {
      value: (_vm.selectedId),
      callback: function($$v) {
        _vm.selectedId = $$v
      },
      expression: "selectedId"
    }
  }, _vm._l((_vm.companyUsers), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.display_name,
        "value": user.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Response Type"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.isResponseTypeRSS),
      callback: function($$v) {
        _vm.isResponseTypeRSS = $$v
      },
      expression: "isResponseTypeRSS"
    }
  }, [_c('el-radio', {
    attrs: {
      "border": "",
      "label": true
    }
  }, [_vm._v("RSS")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "border": "",
      "label": false
    }
  }, [_vm._v("JSON")])], 1)], 1), _vm._v(" "), (_vm.generateUrlSuccess) ? _c('el-form-item', {
    attrs: {
      "label": "Generated Url"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.generatedUrl),
      callback: function($$v) {
        _vm.generatedUrl = $$v
      },
      expression: "generatedUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "loading": _vm.loadingGenerateUrl,
      "disabled": _vm.selectedId === null,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._v("Generate")])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Generate URL")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da017a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/publishing/GenerateURL.vue
// module id = 3165
// module chunks = 3